module.exports = __webpack_public_path__ + "img/choco-shake-minuscules.c9589aa7.jpg";